const getShippingMethodsToStoreInState = charges => {
  const shippingMethods = charges.map(({ shipping, tax }) => {
    const {
      id,
      type,
      hasInsurance,
      insuranceAmount,
      isDefaultShippingOption,
      label,
      shippingAmount,
    } = shipping || {};

    const { total: taxAmount } = tax || {};

    return {
      amount: shippingAmount,
      default: isDefaultShippingOption,
      hasInsurance,
      id,
      insuranceAmount,
      label,
      selected: isDefaultShippingOption,
      taxAmount,
      type,
    };
  });

  if (shippingMethods.find(method => method.default)) {
    return shippingMethods;
  }

  // Select the cheapest option as default if no default was provided by
  // the merchant
  const shippingMethodsWithDefault = selectDefaultShippingMethod(
    shippingMethods,
  );

  return shippingMethodsWithDefault;
};

const selectDefaultShippingMethod = shippingMethods => {
  shippingMethods.sort(
    (a, b) => a.amount.currencyValue - b.amount.currencyValue,
  );
  shippingMethods[0].selected = true;
  return shippingMethods;
};

export { getShippingMethodsToStoreInState };
